import palette from '@inscribe/signal/dist/palette';

const ALL_ACCOUNTS_ID = 'all_accounts';
const AGGREGATE_ACCOUNTS_ID = 'aggregate_accounts';

export default {
  ALL_ACCOUNTS_ID: ALL_ACCOUNTS_ID,
  ALL_ACCOUNTS_OBJECT: {
    id: ALL_ACCOUNTS_ID,
    label: 'All Bank Accounts',
  },

  AGGREGATE_ACCOUNTS_ID: AGGREGATE_ACCOUNTS_ID,
  AGGREGATE_ACCOUNTS_OBJECT: {
    id: AGGREGATE_ACCOUNTS_ID,
    label: 'Aggregate of Accounts',
  },

  MAX_LINE_COLOR: '#12A594',
  AVERAGE_LINE_COLOR: '#7E868C',
  MIN_LINE_COLOR: '#E93D82',

  FILL_COLOR_NEGATIVE_BALANCE: palette['light-error-50'],
};
